// area.js — startet einen Bereich der neuen Oberfläche (App, Admin, Betreiber):
// Theme, Ripple, adaptives Gerüst, API-Fehlerbehandlung, Router, Seitenwechsel.
import { nx } from './prefix.js';
import '../ui/index.css';
import { t } from './i18n.js';
import { installRipple } from '../ui/core/ripple.js';
import { installTooltips } from '../ui/components/tooltip.js';
import { initTheme } from '../ui/theme/theme.js';
import { createScaffold } from '../ui/components/shell.js';
import { createRouter } from './router.js';
import { configureApi } from './api.js';
import { mountPage } from './page.js';
import { snackbar } from '../ui/components/snackbar.js';
import { registerServiceWorker, installNetworkStatus } from './pwa.js';

export function areaBase(fallback) {
  return document.documentElement.dataset.base || fallback;
}

// Brücke für übernommene Module der alten App (src/js/*), die window.tr erwarten
if (typeof window !== 'undefined' && !window.tr) window.tr = (k, v) => t(k, v);

export function startArea({ base, label, destinations, routes, topbar, fab, storageKey, railToggle = true, loginUrl = () => nx('/login') + '?next=' + encodeURIComponent(location.pathname + location.search) }) {
  initTheme();
  installRipple();
  installTooltips();
  registerServiceWorker();
  installNetworkStatus();
  const shell = createScaffold(document.getElementById('app'), { label, destinations, fab, storageKey, railToggle });
  if (topbar) shell.topbar(topbar);
  configureApi({
    onUnauthorized: () => { location.href = typeof loginUrl === 'function' ? loginUrl() : loginUrl; },
    onError: (r) => { if (r.status >= 500 || r.status === 0) snackbar({ text: t('ui.net_error', { msg: r.message || r.code }), error: true, key: 'net' }); },
  });
  const router = createRouter({ base, routes, onChange: (state) => mountPage(state, { shell, router }) });
  router.start();
  return { shell, router };
}
